import { createAsyncThunk } from "@reduxjs/toolkit";
import ReportAPI from "./reportAPI";

export const createReport = createAsyncThunk(
  "reports/createReport",
  async (payload, { rejectWithValue }) => {
    try {
      return await ReportAPI.createReport(payload);
    } catch (err) {
      return rejectWithValue(err.response?.data?.detail || err.message);
    }
  }
);
